// Subtle Goods — 3D spinning SG star (Three.js). Traced from the SG star logo.
import * as THREE from 'https://cdn.jsdelivr.net/npm/three@0.170.0/+esm';
import { RoomEnvironment } from 'https://cdn.jsdelivr.net/npm/three@0.170.0/examples/jsm/environments/RoomEnvironment.js/+esm';

// Polygons in logo pixel space (1172 x 719, y down). o = outline, h = holes.
const SHAPES = [{"o":[449,381,433,386,422,397,417,411,417,436,422,450,432,460,445,466,460,466,468,462,480,452,486,434,488,417,484,404,478,393,472,387,464,383],"h":[]},{"o":[1166,35,1161,34,1152,38,1108,50,1098,54,1045,69,1022,77,949,98,936,103,853,127,830,135,800,143,600,204,590,206,580,210,550,218,514,230,510,216,470,40,459,6,371,143,370,146,362,157,349,180,334,201,333,204,327,212,326,216,320,223,319,226,313,234,312,238,306,245,305,248,299,256,270,303,158,335,108,351,90,355,40,374,25,378,22,380,6,384,10,388,20,392,21,394,24,394,41,406,54,410,65,418,72,420,89,432,120,448,136,458,142,460,162,471,161,474,92,580,91,584,25,688,36,682,38,680,120,638,165,612,224,580,280,548,294,544,306,548,308,550,360,578,362,580,538,674,540,676,612,712,602,659,580,570,564,499,558,478,556,457,552,440,552,417,548,392,548,375,589,352,592,352,593,350,620,336,627,332,648,322,669,310,678,306,743,268,752,264,754,262,792,242,810,232,840,216,917,172,926,168,935,162,1040,106,1078,84,1108,68],"h":[[414,334,426,334,426,332,440,332,441,334,448,334,448,334,452,334,456,336,460,336,462,338,464,338,468,340,470,342,474,344,485,355,486,358,486,354,488,354,488,338,545,340,545,516,544,517,543,528,542,529,542,532,541,533,539,542,535,550,533,551,532,554,529,557,529,558,518,570,516,570,512,574,508,575,506,577,504,577,500,580,497,580,490,583,487,583,486,584,483,584,482,585,479,585,478,586,473,586,472,587,445,589,444,588,423,587,422,586,418,586,418,585,414,585,414,584,410,584,410,583,401,581,391,576,386,572,385,572,376,564,376,562,372,558,368,552,366,550,366,548,364,546,364,543,362,536,362,530,414,530,414,528,422,528,424,534,431,542,437,544,440,544,440,546,458,546,458,546,466,544,474,540,480,534,484,526,484,521,486,520,486,491,484,491,484,492,480,496,479,496,476,500,474,500,470,504,464,507,455,509,454,510,450,510,450,511,445,511,444,512,422,512,422,511,412,510,412,509,403,507,391,501,386,497,385,497,372,484,372,482,366,476,360,464,360,462,358,458,358,455,356,452,356,448,356,448,356,442,354,442,354,417,354,416,356,401,356,400,358,389,360,386,362,381,368,367,370,366,370,364,384,350,386,350,388,346,390,346,394,342,400,340,402,340,405,338,414,336],[209,330,212,330,214,328,216,328,220,326,224,326,224,324,228,324,229,324,234,324,234,322,242,322,242,322,264,320,264,322,284,322,285,324,290,324,290,324,294,324,294,326,298,326,298,326,304,328,306,330,308,330,316,334,318,336,322,338,325,340,326,340,335,350,336,354,339,357,339,360,342,366,342,372,343,372,342,377,287,376,280,369,274,366,266,365,266,364,256,364,256,365,248,366,242,369,238,374,238,382,245,388,250,388,252,390,264,392,264,394,268,394,269,394,284,396,284,398,288,398,288,398,292,398,292,400,296,400,297,400,308,404,311,406,314,406,322,410,323,412,328,414,330,416,332,416,342,429,345,435,347,444,348,444,348,450,349,451,349,462,348,463,348,470,347,470,346,478,344,480,344,482,342,486,337,492,337,494,330,501,328,501,326,504,324,504,320,508,312,512,306,513,306,514,302,514,302,515,298,515,298,516,294,516,294,517,289,517,288,518,282,518,282,519,272,519,272,520,245,520,244,519,236,519,236,518,230,518,230,517,225,517,224,516,217,515,216,514,211,513,208,511,206,511,198,507,196,505,195,505,194,503,189,501,176,486,170,476,170,471,168,470,168,460,166,460,167,452,228,452,229,458,232,464,235,467,235,468,243,474,248,474,248,474,268,474,269,474,272,474,273,472,278,472,280,470,282,470,286,464,286,460,286,460,286,458,286,455,284,454,284,452,278,447,267,445,266,444,262,444,262,443,258,443,258,442,254,442,254,441,250,441,250,440,246,440,246,439,242,439,242,438,238,438,238,437,234,437,234,436,230,436,230,435,225,435,224,434,218,433,218,432,212,431,210,429,207,429,201,426,200,424,196,423,194,420,192,420,180,408,176,398,174,390,174,390,174,371,174,370,176,363,178,360,178,356,180,354,182,351,184,348,184,347,196,336,198,336,199,334]]}];

function ring(flat) {
  const pts = [];
  for (let i = 0; i < flat.length; i += 2) {
    const p = new THREE.Vector2(flat[i], -flat[i + 1]);
    if (!pts.length || !pts[pts.length - 1].equals(p)) pts.push(p);
  }
  if (pts.length > 2 && pts[0].equals(pts[pts.length - 1])) pts.pop();
  return pts;
}

function extrude(shapes, depth, bevel) {
  return new THREE.ExtrudeGeometry(shapes, {
    depth,
    bevelEnabled: true,
    bevelThickness: bevel,
    bevelSize: bevel * 0.7,
    bevelSegments: 4,
    curveSegments: 1,
  });
}

// Solid black star with a raised white "sg" on each face. The back letters are
// turned around so they read correctly (not mirrored) when the star spins round.
function buildGeometries(depth) {
  const star = SHAPES.filter((s) => s.h.length).map(({ o }) => new THREE.Shape(ring(o)));
  const islands = SHAPES.filter((s) => !s.h.length).map((s) => ring(s.o));
  const letters = SHAPES.flatMap(({ h }) => h).map((flat) => {
    const s = new THREE.Shape(ring(flat));
    islands.forEach((pts) => {
      const box = new THREE.Box2().setFromPoints(s.getPoints());
      if (box.containsPoint(pts[0])) s.holes.push(new THREE.Path(pts));
    });
    return s;
  });

  const starBevel = depth * 0.14;
  const starGeo = extrude(star, depth, starBevel);
  const faceFront = depth + starBevel;
  const faceBack = -starBevel;

  // Thin letter plate, centred on z = 0, partly sunk into the face it sits on.
  const plateDepth = depth * 0.2;
  const plate = extrude(letters, plateDepth, depth * 0.04);
  plate.translate(0, 0, -plateDepth / 2);
  plate.computeBoundingBox();
  const cx = plate.boundingBox.getCenter(new THREE.Vector3()).x;
  const rise = depth * 0.06;

  const front = plate.clone().translate(0, 0, faceFront + rise);
  // rotateY(PI) turns the plate to face backwards without mirroring its outline.
  const back = plate.clone().translate(-cx, 0, 0).rotateY(Math.PI).translate(cx, 0, faceBack - rise);

  starGeo.computeBoundingBox();
  const offset = starGeo.boundingBox.getCenter(new THREE.Vector3()).negate();
  [starGeo, front, back].forEach((g) => g.translate(offset.x, offset.y, offset.z));
  return { starGeo, letterGeos: [front, back] };
}

function init(el) {
  const secondsPerTurn = parseFloat(el.dataset.speed) || 6;
  const color = new THREE.Color(el.dataset.color || '#0b0b0b');
  const letterColor = new THREE.Color(el.dataset.letterColor || '#ffffff');
  // mode "flash": the star faces front and blinks like a neon sign instead of spinning.
  const flash = el.dataset.mode === 'flash';

  let renderer;
  try {
    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  } catch (e) {
    return; // No WebGL: the flat logo fallback stays visible.
  }
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.domElement.className = 'sg-star3d__canvas';
  renderer.domElement.setAttribute('aria-hidden', 'true');
  el.appendChild(renderer.domElement);

  const scene = new THREE.Scene();
  const pmrem = new THREE.PMREMGenerator(renderer);
  scene.environment = pmrem.fromScene(new RoomEnvironment(), 0.04).texture;

  const key = new THREE.DirectionalLight(0xffffff, 1.6);
  key.position.set(400, 600, 900);
  scene.add(key);

  const material = new THREE.MeshPhysicalMaterial({
    color,
    metalness: 0.15,
    roughness: 0.3,
    clearcoat: 1,
    clearcoatRoughness: 0.1,
  });
  const letterMaterial = new THREE.MeshPhysicalMaterial({
    color: letterColor,
    roughness: 0.45,
    clearcoat: 0.6,
    clearcoatRoughness: 0.2,
  });
  const { starGeo, letterGeos } = buildGeometries(110);
  const mesh = new THREE.Mesh(starGeo, material);
  const pivot = new THREE.Group();
  pivot.add(mesh, ...letterGeos.map((g) => new THREE.Mesh(g, letterMaterial)));
  scene.add(pivot);

  // Fit the camera so the star never clips while it turns.
  mesh.geometry.computeBoundingBox();
  const size = mesh.geometry.boundingBox.getSize(new THREE.Vector3());
  const radius = size.x / 2;
  const camera = new THREE.PerspectiveCamera(30, 1, 1, 10000);
  function resize() {
    const w = el.clientWidth, h = el.clientHeight;
    if (!w || !h) return;
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    const vFov = THREE.MathUtils.degToRad(camera.fov);
    const hFov = 2 * Math.atan(Math.tan(vFov / 2) * camera.aspect);
    const fitW = (size.x / 2) * 1.12 / Math.tan(hFov / 2);
    const fitH = (size.y / 2) * 1.25 / Math.tan(vFov / 2);
    const dist = Math.max(fitW, fitH) + size.x / 2;
    camera.position.set(0, 0, dist);
    camera.lookAt(0, 0, 0);
    camera.updateProjectionMatrix();
    render(last);
  }

  // Neon-sign blink, as "on" windows over one cycle (0–1): a long hold, a
  // quick double stutter, a shorter hold, then dark until the cycle restarts.
  const FLASH_ON = [[0, 0.52], [0.545, 0.565], [0.585, 0.6], [0.62, 0.82]];

  // Spin time only advances while playing, so pausing freezes the star in place.
  let spin = 0, last = 0, prev = null, paused = false;
  function render(t) {
    if (prev !== null && !paused) spin += t - prev;
    prev = t;
    last = t;
    if (flash) {
      const phase = (spin / 1000 / secondsPerTurn) % 1;
      pivot.visible = FLASH_ON.some(([a, b]) => phase >= a && phase < b);
      pivot.rotation.y = Math.sin(spin / 2400) * 0.16;
      pivot.rotation.x = Math.sin(spin / 1700) * 0.07;
    } else {
      pivot.rotation.y = -0.5 + (spin / 1000 / secondsPerTurn) * Math.PI * 2;
      pivot.rotation.x = Math.sin(spin / 1600) * 0.12;
    }
    pivot.position.y = Math.sin(spin / 1100) * radius * 0.025;
    renderer.render(scene, camera);
  }

  // Click / tap / Enter / Space toggles the spin.
  el.setAttribute('role', 'button');
  el.setAttribute('tabindex', '0');
  function setLabel() { el.setAttribute('aria-label', paused ? 'Play star animation' : 'Pause star animation'); }
  function toggle() { paused = !paused; setLabel(); }
  setLabel();
  el.addEventListener('click', toggle);
  el.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
  });

  let visible = true;
  new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; }).observe(el);
  new ResizeObserver(resize).observe(el);
  resize();

  renderer.setAnimationLoop((t) => {
    if (visible && !document.hidden) render(t);
    else prev = null;
  });
  el.classList.add('is-ready');
}

document.querySelectorAll('[data-sg-star3d]').forEach(init);
